module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "loader"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader.gif",
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.authenticated) ? _c('top-header') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.authenticated) ? _c('div', {
    class: _vm.sidebarClasses
  }, [_c('sidebar')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.containerClasses
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dee47f7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 448
// module chunks = 1